import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../../components/DrawerWithAutoWidth';
import AddAudiCalculationSettingsForm, { type CompanySpecsForAudiCalculation } from './AddAudiCalculationSettingsForm';

export type AudiCalculationSettingsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    moduleId: string;
    company: CompanySpecsForAudiCalculation;
};

const AudiCalculationSettingsDrawer = ({ onClose, visible, moduleId, company }: AudiCalculationSettingsDrawerProps) => {
    const { t } = useTranslation(['audiCalculationModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('audiCalculationModuleDetails:settings.create.cancelButton')}</Button>
                    <Button form="addAudiCalculationSettings" htmlType="submit" type="primary">
                        {t('audiCalculationModuleDetails:settings.create.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('audiCalculationModuleDetails:settings.create.title')}
            visible={visible}
            destroyOnClose
        >
            <AddAudiCalculationSettingsForm company={company} moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default AudiCalculationSettingsDrawer;

export const useAudiCalculationSettingsDrawer = (moduleId: string, company: CompanySpecsForAudiCalculation) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => (
            <AudiCalculationSettingsDrawer
                company={company}
                moduleId={moduleId}
                onClose={actions.close}
                visible={visible}
            />
        ),
    };
};
